import {
  ComponentSelection,
  QueryBuilderQuery,
  QueryBuilderRow,
  QueryBuilderSubquery,
  ViewpointBuilderFilters,
  isQueryBuilderSubquery,
} from '@ardoq/api-types';
import { PERSPECTIVES_TO_ADVANCED_SEARCH_OPERATOR_REPLACEMENTS } from '../types';

// NOTE: We have deprecated the following operators within advanced search,
// but they are *not* considered legacy within perspectives:
// - (not_)contains
// - (not_)contains_phrase
// - (not_)contains_terms
// Therefore, the name 'legacy operator' is somewhat misleading, because they
// are not deprecated throughout the whole app.

export const mapContainsOperatorForQueryRules = (
  rules: QueryBuilderRow[]
): QueryBuilderRow[] =>
  rules.map(ruleOrSubquery =>
    isQueryBuilderSubquery(ruleOrSubquery)
      ? {
          ...ruleOrSubquery,
          rules: mapContainsOperatorForQueryRules(ruleOrSubquery.rules),
        }
      : {
          ...ruleOrSubquery,
          operator:
            PERSPECTIVES_TO_ADVANCED_SEARCH_OPERATOR_REPLACEMENTS.get(
              ruleOrSubquery.operator
            ) ?? ruleOrSubquery.operator,
        }
  );

const consolidateLegacyOperators = (
  query: QueryBuilderSubquery
): QueryBuilderSubquery => ({
  ...query,
  rules: mapContainsOperatorForQueryRules(query.rules),
});

export const consolidateOperatorsForQuery = (
  query: QueryBuilderQuery
): QueryBuilderQuery => ({
  ...query,
  rules: [
    query.rules[0], // search context rule
    consolidateLegacyOperators(query.rules[1]), // user-defined rules
  ],
});

// The operators `contains`, `contains_phrase`, `not_contains`, `not_contains_phrase` are deprecated
// but still exists in saved slides and URLs. This is a first step towards consolidating
// these operators to only use `contains_substring` and `not_contains_substring`.
export const consolidateOperatorsForViewpointComponentSelection = (
  componentSelection: ComponentSelection
): ComponentSelection => ({
  ...componentSelection,
  ...(componentSelection.startQuery && {
    startQuery: consolidateOperatorsForQuery(componentSelection.startQuery),
  }),
});

export const consolidateLegacyOperatorsForViewpointFilters = (
  filters: ViewpointBuilderFilters
) => {
  const newFilters: ViewpointBuilderFilters = {};
  Object.entries(filters).forEach(([id, filter]) => {
    newFilters[id] = {
      ...filter,
      rules: filter.rules.map(rule => ({
        ...rule,
        operator:
          PERSPECTIVES_TO_ADVANCED_SEARCH_OPERATOR_REPLACEMENTS.get(
            rule.operator
          ) ?? rule.operator,
      })),
    };
  });
  return newFilters;
};
